module.exports = __webpack_public_path__ + "img/tamiltoken-social-media-influencer.44ef7be2.jpg";